<script>
import router from '@/router'
import { layoutComputed } from '@/state/helpers'

import NavBar from '@/components/layoutComponents/nav-bar'
import SideBar from '@/components/layoutComponents/side-bar'

/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar },
  data() {
    return {
      // isMenuCondensed: false,
    }
  },
  computed: {
    ...layoutComputed,
    isMenuCondensed() {
      return window.sessionStorage.getItem('menuCollapsed')
    },
  },
  created: () => {
    document.body.removeAttribute('data-layout', 'horizontal')
    document.body.removeAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-layout-size', 'boxed')
    document.body.classList.remove('auth-body-bg')
  },
  methods: {
    toggleMenu() {
      if (this.isMenuCondensed == false) {
        window.sessionStorage.setItem('menuCollapsed', true)
      } else if (this.isMenuCondensed == true) {
        window.sessionStorage.setItem('menuCollapsed', false)
      }
      document.body.classList.toggle('sidebar-enable')

      if (window.screen.width >= 992) {
        if (this.isMenuCondensed == false) {
          document.body.classList.toggle('vertical-collpsed')
        } else {
          document.body.classList.toggle('vertical-collpsed')
        }
        // eslint-disable-next-line no-unused-vars
        // router.afterEach((routeTo, routeFrom) => {
        //   document.body.classList.remove('sidebar-enable')
        //   document.body.classList.remove('vertical-collpsed')
        // })
      } else {
        // eslint-disable-next-line no-unused-vars
        // router.afterEach((routeTo, routeFrom) => {
        //   document.body.classList.remove('sidebar-enable')
        // })
        if (this.isMenuCondensed == false) {
          document.body.classList.remove('vertical-collpsed')
        } else {
          document.body.classList.remove('vertical-collpsed')
        }
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
    hideRightSidebar() {
      document.body.classList.remove('right-bar-enabled')
    },
  },
  watch:{
     "$route.name"(val) {
       if(val == "admin-Kanban") {
        this.isMenuCondensed = false
        window.sessionStorage.setItem('menuCollapsed', true)
        document.body.classList.toggle('vertical-collpsed')
      }
    }
  },
  mounted() {
    if(this.$route.name == "admin-Kanban") {
        this.isMenuCondensed = false
        window.sessionStorage.setItem('menuCollapsed', true)
        document.body.classList.toggle('vertical-collpsed')
      }
    window.sessionStorage.setItem('menuCollapsed', false)
    if (this.loader === true) {
      document.getElementById('preloader').style.display = 'block'
      document.getElementById('status').style.display = 'block'

      setTimeout(function() {
        document.getElementById('preloader').style.display = 'none'
        document.getElementById('status').style.display = 'none'
      }, 400)
    } else {
      document.getElementById('preloader').style.display = 'none'
      document.getElementById('status').style.display = 'none'
    }
  },
}
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <NavBar />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
